import { render, staticRenderFns } from "./initial-arrears-setup.vue?vue&type=template&id=871522ac&scoped=true"
import script from "./initial-arrears-setup.vue?vue&type=script&lang=js"
export * from "./initial-arrears-setup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871522ac",
  null
  
)

export default component.exports